import React, { useEffect, useState } from "react";
import { getAllForms, getDoneBookings } from "../../services/formService";
import "./MostBookedTours.css";

const MostBookedTours = () => {
  const [mostBooked, setMostBooked] = useState({});

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const formsResponse = await getAllForms();
      const doneBookingsResponse = await getDoneBookings();

      const allBookings = [
        ...(formsResponse?.forms || []),
        ...(doneBookingsResponse?.doneBookings || []),
      ];

      const tourCounts = allBookings.reduce((acc, booking) => {
        if (booking.cart && Array.isArray(booking.cart)) {
          booking.cart.forEach((item) => {
            const tourType = item.typeOfTour || "Unknown";
            if (!acc[tourType]) {
              acc[tourType] = {};
            }
            acc[tourType][item.name] =
              (acc[tourType][item.name] || 0) + item.quantity;
          });
        }
        return acc;
      }, {});

      const mostBookedTours = Object.keys(tourCounts).reduce((acc, type) => {
        const mostBookedTour = Object.entries(tourCounts[type]).reduce(
          (a, b) => (a[1] > b[1] ? a : b),
          ["", 0]
        );
        acc[type] = { name: mostBookedTour[0], quantity: mostBookedTour[1] };
        return acc;
      }, {});

      setMostBooked(mostBookedTours);
    } catch (error) {
      console.error("Error fetching data:", error);
      setMostBooked({});
    }
  };

  return (
    <div className="mostBookedTours">
      <h2>Most Booked Tours</h2>
      <ul className="tours-list">
        {Object.entries(mostBooked).map(([type, { name, quantity }]) => (
          <li key={type} className="tour-item">
            <span className="tour-name">
              {type}: {name || "No Data"}
            </span>
            <span className="tour-quantity">({quantity} booked)</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MostBookedTours;
